module.exports = __webpack_public_path__ + "img/img_app_zixun@3x.baf1ff48.png";